import {Button} from 'antd';
import React, {useState} from 'react';
import {isMobile} from 'react-device-detect';

import {
  brandConfig,
  isClientTrial,
  openLeadokuSubscription,
  ChoosePlanLeadokuModal,
  ChoosePlanGxModal,
  PLANS,
} from '../../libs/ui/src';
import {Plans} from '../../libs/types/src';

import {CalendlyModal} from '../Calendly/CalendlyModal';

export default function UpgradeButton({
  client,
  activateRegularPlan,
  onDemoSubmit,
  activateRegularPlanGx,
  activatePlanFromTrial,
  info,
}) {
  if (brandConfig.isGx) {
    if (info?.detail?.plan === Plans.FREE) {
      return (
        <UpgradeFromFreePlan activateRegularPlanGx={activateRegularPlanGx} onDemoSubmit={onDemoSubmit} />
      );
    }
    if (client.type === Plans.TRIAL && client.awaiting_subscription_activation) {
      return (
        <Button
          type="primary"
          size="small"
          style={{fontSize: '.9em', color: 'white'}}
          onClick={() => activateRegularPlan(undefined, info?.detail?.plan_term || 'monthly')}
        >
          Upgrade
        </Button>
      );
    }
    if (!isClientTrial(client.type)) return null;
    return (
      <UpgradeFromTrialPlan
        activatePlanFromTrial={activatePlanFromTrial}
        client={client}
        onDemoSubmit={onDemoSubmit}
      />
    );
  }
  return null;
}

const periodSlugMap = {
  'monthly': '',
  'quarterly': '-3m',
  'annual': '-yr',
}

const UpgradePlanWithSelection = ({isLoading, onSelection, onDemoSubmit}) => {
  const [showModal, setShowModal] = useState(false);
  const [period, setPeriod] = useState('monthly');
  const [showDemoModal, setShowDemoModal] = useState(false);
  const onClick = plan => {
    if (plan.key === PLANS.ENTERPRISE) {
      setShowDemoModal(true);
      setShowModal(false);
      return;
    }
    const period_slug = periodSlugMap[period] ?? '';
    onSelection(`${plan.key}-1-user${period_slug}`);
    setShowModal(false);
  };
  return (
    <>
      <Button
        loading={isLoading}
        type="primary"
        size="small"
        style={{fontSize: '.9em', color: 'white'}}
        onClick={() => setShowModal(true)}
      >
        Upgrade
      </Button>
      <ChoosePlanGxModal
        visible={showModal}
        onCancel={() => setShowModal(false)}
        period={period}
        onChangePeriod={e => setPeriod(e.target.value)}
        onClick={onClick}
      />
      <CalendlyModal
        onSuccess={onDemoSubmit}
        open={showDemoModal}
        onCancel={() => setShowDemoModal(false)}
        isMobile={isMobile}
        title="Schedule Demo Call"
      />
    </>
  );
}

const UpgradeFromTrialPlan = ({activatePlanFromTrial, client, onDemoSubmit}) => {
  const [isLoading, setIsLoading] = useState(false);
  const onSelection = (plan_id) => {
    activatePlanFromTrial(setIsLoading, plan_id, client);
  }
  return (
    <UpgradePlanWithSelection isLoading={isLoading} onSelection={onSelection} onDemoSubmit={onDemoSubmit} />
  );
};

const UpgradeFromFreePlan = ({activateRegularPlanGx, onDemoSubmit}) => {
  const [isLoading, setIsLoading] = useState(false);
  const onSelection = (plan_id) => {
    activateRegularPlanGx(setIsLoading, plan_id);
  }
  return (
    <UpgradePlanWithSelection isLoading={isLoading} onSelection={onSelection} onDemoSubmit={onDemoSubmit} />
  );
};
